module.exports = __webpack_public_path__ + "static/img/5.55334575.png";